import { Component } from '@angular/core';
import * as jQuery from 'jquery';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/app.component.ts